<span class="app-badge-upper">
  <ng-content></ng-content>
  <span
    *ngIf="text !== null && text !== undefined && text !== ''"
    class="app-badge-upper__content"
    [ngClass]="[
      'app-badge-upper__content--' + variant,
      'app-badge-upper__content--' + size,
    ]"
  >
    {{ text }}
  </span>
</span>
